/* eslint-disable import/no-mutable-exports */
/* import pvLogo from './assets/pv_logo_pantone.jpg';
import ofLogo from './assets/OF_Logo_RGB_RZ_190924.jpg'; */
import wdLogo from './assets/entry_transparent_735.png';

/* const config = {
  heading: '24. Operngala am 30. November 2024',
  progressHeading: 'Bitte fügen Sie Ihre Mitarbeiter hinzu',
  index: {
    title: 'Willkommen bei der Registrierung zur 24. Operngala.',
    description: 'Bitte geben Sie Ihren persönlichen Einladungscode ein.',
    description2: 'Diesen finden Sie auf Ihrer Einladungskarte.',
  },
  confirmation: {
    accepted: 'Ich möchte die Operngala besuchen',
    declined: 'Ich kann nicht kommen und möchte absagen',
  },
  logos: [
    { src: pvLogo, width: 220, smWidth: 180 },
    { src: ofLogo },
  ],
  footerLinks: [
    {
      name: 'Impressum (Patronatsverein)',
      link: 'https://patronatsverein.de/impressum/',
    },
    {
      name: 'Impressum (Oper Frankfurt)',
      link: 'https://oper-frankfurt.de/de/impressum/',
    },
    {
      name: 'Datenschutz',
      type: 'privacy',
    },
    {
      name: 'Technik',
      link: 'https://wirkung.group/digital/',
    },
  ],

}; */

const config = {
  heading: 'Lerne .entry kennen',
  progressHeading: 'Bitte fügen Sie Ihre Mitarbeiter hinzu',
  logos: [
    { src: wdLogo, width: 250, smWidth: 200 },
  ],
  index: {
    title: 'Willkommen bei der Registrierung',
    description: 'Bitte geben Sie Ihren persönlichen Einladungscode ein.',
    description2: 'Diesen finden Sie auf Ihrer Einladungskarte.',
  },
  confirmation: {
    accepted: 'Ich möchte einen geilen Einlass',
    declined: 'Ich möchte weiter mit einer Excelliste arbeiten',
  },
  footerLinks: [
    {
      name: 'Impressum',
      link: 'https://www.wirkung.group/impressum',
    },
    {
      name: 'Datenschutz',
      link: 'https://www.wirkung.group/datenschutz',
    },
    {
      name: 'AGB',
      link: 'https://www.wirkung.group/agb',
    },
    {
      name: 'Technik',
      link: 'https://wirkung-digital.de/',
    },
  ],

};

export default config;
